import React, { FC, useEffect, useState } from 'react'
import { MdArrowUpward } from 'react-icons/md'
import throttle from 'lodash/throttle'
import { scrollAnimation } from '../utils/scroll-handler'

interface Props {
  num?: number
  max?: number
  className?: string
}
const BackTop: FC<Props> = (props) => {
  const { num = 0, max = 1600, className = '' } = props
  const [show, setShow] = useState<boolean>(false)
  const throttleFunc = throttle(() => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    setShow(scrollTop >= max)
    // @ts-ignore
    document.querySelector(
      '.udesk-client-btn'
      // @ts-ignore
    )?.style.transform = `translateY(-${scrollTop >= max ? 4 : 0}rem)`
  }, 500)
  useEffect(() => {
    window.addEventListener('scroll', throttleFunc)
    return () => {
      window.removeEventListener('scroll', throttleFunc)
    }
  }, [])
  return (
    <div
      onClick={() => scrollAnimation(num, 0)}
      className={`cursor-pointer z-20 w-11 h-11 bg-black rounded-1/2 flex items-center justify-center fixed bottom-10 right-4 md:right-8 md:bottom-14 rounded-full transform-gpu transition-opacity ${
        show ? 'opacity-100' : 'opacity-0'
      } ${className}`}
    >
      <MdArrowUpward color="#fff" size="26" />
    </div>
  )
}

export default BackTop
